import axios from '@/utils/request' // 正式
// import axios from 'axios' // mock

const ApiUrl = '/admin_api/v1/product/projects'
export function getList(params) {
  return axios.get(`${ApiUrl}/`, {
    params
  })
}

export function del(project_id) {
  return axios.delete(`${ApiUrl}/${project_id}/`)
}

export function getDetail(project_id) {
  return axios.get(`${ApiUrl}/${project_id}/`)
}

export function add(data) {
  return axios.post(`${ApiUrl}/`, data)
}

export function edit(project_id, data) {
  return axios.put(`${ApiUrl}/${project_id}/`, data)
}
